var _ellipse, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 66,
    viewBox: "0 0 67 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.793,
    cy: 32.5,
    rx: 17.793,
    ry: 17.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.0215 35.9834L40.0184 35.9852L36.2768 38.1127L32.5383 40.2384C32.5375 40.2389 32.5366 40.2393 32.5358 40.2398C30.495 41.3947 29.0863 41.2614 28.3175 40.8251C27.561 40.3958 26.7543 39.2909 26.7543 37.005V28.495C26.7543 26.1909 27.5632 25.0905 28.3145 24.6658C29.081 24.2325 30.4906 24.1025 32.5369 25.2608C32.5373 25.2611 32.5378 25.2613 32.5383 25.2616L36.2768 27.3873L40.0184 29.5149L40.0215 29.5166C42.0684 30.6757 42.6244 31.9243 42.6244 32.75C42.6244 33.5757 42.0684 34.8243 40.0215 35.9834ZM33.2315 2C27.0618 2 21.028 3.79923 15.8929 7.17386C10.7575 10.5487 6.74986 15.349 4.38192 20.9716C2.01382 26.5945 1.39368 32.7838 2.60138 38.7553C3.80903 44.7266 6.78905 50.207 11.1593 54.5052C15.5292 58.8031 21.0927 61.7264 27.1447 62.9104C33.1965 64.0943 39.4697 63.487 45.1724 61.1637C50.8754 58.8404 55.7551 54.9037 59.1908 49.8465C62.6268 44.7889 64.4629 38.8392 64.4629 32.75C64.4629 24.5838 61.1642 16.7589 55.3036 10.9948C49.4441 5.23179 41.5039 2 33.2315 2Z",
    fill: "#1886CD",
    stroke: "white",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPly);
export default __webpack_public_path__ + "static/media/ply.d66db5bbbf2de9ee33599668f9acaa7e.svg";
export { ForwardRef as ReactComponent };